import React from 'react';
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';

export type CampaignGroup = {
  id: string;
  groupName: string;
  campaigns: number;
  created: string;
};

type CampaignGroupsTableProps = {
  groups: CampaignGroup[];
  onGroupClick: (group: CampaignGroup) => void;
  onManageClick: (group: CampaignGroup) => void;
};

export const CampaignGroupsTable: React.FC<CampaignGroupsTableProps> = ({
  groups,
  onGroupClick,
  onManageClick,
}) => {
  return (
    <Box maxHeight="600px" overflowY="auto" width="100%">
      <Table variant="simple" width="100%">
        <Thead>
          <Tr
            bg="surface.control"
            borderBottom="1px"
            borderColor="border.layout">
            <Th
              color="text.darkGray"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Group Name
            </Th>
            <Th
              color="text.darkGray"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Campaigns
            </Th>
            <Th
              color="text.darkGray"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Created
            </Th>
            <Th
              color="text.darkGray"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Manage
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {groups.map((group) => (
            <Tr
              key={group.id}
              borderBottom="1px"
              borderColor="border.layout"
              _hover={{ bg: 'surface.hover' }}>
              <Td fontSize="md" color="text.title" px={4} py={4}>
                <Text
                  cursor="pointer"
                  _hover={{
                    color: 'icon.green',
                    textDecoration: 'underline',
                  }}
                  onClick={() => onGroupClick(group)}>
                  {group.groupName}
                </Text>
              </Td>
              <Td fontSize="md" color="text.title" px={4} py={4}>
                <HStack spacing={1}>
                  <Text>{group.campaigns}</Text>
                  <Icon
                    iconName="info"
                    boxSize={4}
                    color="gray.400"
                    cursor="pointer"
                  />
                </HStack>
              </Td>
              <Td fontSize="md" color="text.title" px={4} py={4}>
                {group.created}
              </Td>
              <Td px={4} py={4}>
                <Icon
                  iconName="pencil"
                  boxSize={5}
                  color="text.muted"
                  cursor="pointer"
                  onClick={() => onManageClick(group)}
                  _hover={{ color: 'icon.green' }}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
